import React from 'react';

const formatarPreco = (valor) => {
  const numero = Number(valor);

  if (Number.isNaN(numero)) {
    return `R$ ${valor}`;
  }

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(numero);
};

function AbaModeracao({
  promocaoSelecionada,
  setPromocaoSelecionada,
  excluirPromocao,
  promocoes,
  buscarPromocoes,
  aprovarDenuncia,
  temMaisDados,
  somenteConsulta = false,
}) {
  return (
    <div className="moderation-panel">
      <div className="moderation-panel__header">
        <span className="moderation-panel__counter">
          {promocoes.length} {promocoes.length === 1 ? 'item' : 'itens'}
        </span>
      </div>

      {somenteConsulta && (
        <div className="routine-callout routine-callout--warm" style={{ marginBottom: '16px' }}>
          <p className="routine-callout__text">
            Perfil técnico em modo somente consulta. A fila pode ser analisada, mas não pode aprovar ou excluir postagens.
          </p>
        </div>
      )}

      {promocaoSelecionada ? (
        <div className="moderation-detail">
          <button
            type="button"
            className="routine-btn routine-btn--soft"
            onClick={() => setPromocaoSelecionada(null)}
          >
            Voltar para a fila
          </button>

          <div className="moderation-detail__grid">
            <div className="moderation-detail__media">
              {promocaoSelecionada.url_foto ? (
                <img
                  src={promocaoSelecionada.url_foto}
                  alt={promocaoSelecionada.nome_produto}
                  className="moderation-detail__image"
                />
              ) : (
                <div className="moderation-detail__placeholder">Sem imagem</div>
              )}
            </div>

            <div className="moderation-detail__content">
              <span className="moderation-detail__pill">Postagem denunciada</span>
              <h4 className="moderation-detail__title">{promocaoSelecionada.nome_produto}</h4>
              <p className="moderation-detail__price">{formatarPreco(promocaoSelecionada.preco)}</p>
              <p className="moderation-detail__meta">
                <strong>Postado por:</strong> {promocaoSelecionada.nome_usuario} ({promocaoSelecionada.origem?.toUpperCase()})
              </p>

              <div className="moderation-detail__alert">
                Esta postagem recebeu <strong>{promocaoSelecionada.qtd_denuncias} denúncia(s)</strong> da comunidade.
              </div>

              {somenteConsulta ? (
                <div className="routine-callout">
                  <p className="routine-callout__text">
                    Consulta liberada. As decisões de moderação ficam reservadas aos perfis com permissão de ação.
                  </p>
                </div>
              ) : (
                <div className="routine-actions">
                  <button
                    type="button"
                    className="routine-btn routine-btn--primary"
                    onClick={() => aprovarDenuncia(promocaoSelecionada.id)}
                  >
                    Aprovar denúncia
                  </button>
                  <button
                    type="button"
                    className="routine-btn routine-btn--danger"
                    onClick={() => excluirPromocao(promocaoSelecionada.id, promocaoSelecionada.url_foto)}
                  >
                    Excluir definitivamente
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <>
          {promocoes.length === 0 ? (
            <div className="moderation-empty">
              <h4 className="moderation-empty__title">Fila limpa</h4>
              <p className="moderation-empty__text">Não há nenhuma postagem denunciada neste momento.</p>
            </div>
          ) : (
            <div className="routine-table-wrap">
              <table className="routine-table">
                <thead>
                  <tr>
                    <th>Produto / Loja</th>
                    <th style={{ textAlign: 'center' }}>Alerta</th>
                    <th style={{ textAlign: 'center' }}>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {promocoes.map((promo) => (
                    <tr key={promo.id}>
                      <td>
                        <strong>{promo.nome_produto}</strong>
                        <br />
                        <small style={{ color: '#64748b' }}>{promo.nome_usuario}</small>
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <span className="moderation-badge">
                          {promo.qtd_denuncias} denúncia{promo.qtd_denuncias === 1 ? '' : 's'}
                        </span>
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <button
                          type="button"
                          className="routine-btn routine-btn--soft"
                          onClick={() => setPromocaoSelecionada(promo)}
                        >
                          Analisar
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {temMaisDados && promocoes.length > 0 && (
            <div className="moderation-panel__footer">
              <button type="button" className="routine-btn routine-btn--primary" onClick={() => buscarPromocoes(false)}>
                Carregar mais
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default AbaModeracao;
